export default __webpack_public_path__ + "static/media/480_dummy2016-diy01-de.0babdb42.png";